import { httpAdminReport } from "../helper/http-common";
class AdminGemstoneReportService {
    GetRetailerDropdownList(inputData) {
        return httpAdminReport.post("/AdminGemstonereports/Admin_ExtendedGemstoneChartRetailerDropDownList", inputData)
    }
    GetVendorDropdownList(inputData) {
        return httpAdminReport.post("/AdminGemstonereports/Admin_ExtendedGemstoneChartVendorDropDownList", inputData)
    }
    CheckDealermembers(inputData) {
        return httpAdminReport.post("/Admin_JewelryReport/CheckDealermembers", inputData);
    }
    GemstoneChartForCutGrade(inputData) {
        return httpAdminReport.post("/AdminGemstonereports/GemstoneChartForCutGrade", inputData);
    }
    LoadChartReports(inputData) {
        return httpAdminReport.post("/AdminGemstonereports/LoadChartReports", inputData);
    }
    GetTopGemstoneAttributeTableList(inputData) {
        return httpAdminReport.post("/AdminGemstonereports/GetGemstoneReportForTableChart", inputData);
    }
    GetRecentGemstoneAttributeTableList(inputData) {
        return httpAdminReport.post("/AdminGemstonereports/GetGemstoneReportForTableChartAll", inputData);
    }
    GetAllChartForTableList(inputData) {
        return httpAdminReport.post("/AdminGemstonereports/GetGemstoneReportForTableChartAll20R", inputData);
    }
    GetCSVChartForTableList(inputData) {
        return httpAdminReport.post("/AdminGemstonereports/ExportGemstoneReportForTableChartAll", inputData, {
            responseType: "arraybuffer",
        });
    }

    GetPDFChartForTableList(inputData) {
        return httpAdminReport.post("/AdminGemstonereports/ExportGemstoneReportForTableChartAll_PDF", inputData, {
            responseType: "arraybuffer",
        });
    }
}

export default new AdminGemstoneReportService();
